import React from 'react'
import PropTypes from 'prop-types'

export const GGToggle = ({
  checked,
  onChange,
  labelOn,
  labelOff,
  label,
  disabled = false,
  className = '',
}) => {
  const displayLabel = (labelOn && labelOff) ? (checked ? labelOn : labelOff) : label

  const handleClick = () => {
    if (!disabled && onChange) {
      onChange(!checked)
    }
  }

  return (
    <div className={[ 'gg-toggle-wrapper', className, disabled && 'disabled' ].filter(Boolean).join(' ')}>
      <label className="toggle-container">
        <input
          type="checkbox"
          checked={checked}
          onChange={handleClick}
          disabled={disabled}
          className="toggle-input"
        />
        <div className={[ 'toggle-track', checked && 'is-on' ].filter(Boolean).join(' ')}>
          <span className="toggle-thumb"/>
        </div>
      </label>
      {displayLabel &&
        <span className="toggle-label-text">
        {displayLabel}
        </span>
      }
    </div>
  )
}

GGToggle.propTypes = {
  checked: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  labelOn: PropTypes.string,
  labelOff: PropTypes.string,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  className: PropTypes.string,
}
